import { Component, OnInit } from '@angular/core';
import { Entidad } from '../../../model/entidad.model';
import { EntidadService } from '../../../services/firestore/entidad.service';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html',
})

export class FooterComponent  implements OnInit {

  public entidad: Entidad;

  constructor(private entidadService: EntidadService) {
  }

  ngOnInit(): void {
    this.entidadService.getEntidades().subscribe(data => {
      data.forEach((entidadData: any) => {
        this.entidad = {...entidadData as Entidad};
      });
    });
  }
}
